var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dg-grid-content',{attrs:{"start":{ mobile: 1, desktop: 3 },"size":{ mobile: 4, desktop: 8 }}},[_c('accreditations-loading',{attrs:{"title":_vm.$t('common.onboarding.review-user-register.title'),"description":_vm.$t('common.onboarding.review-user-register.loading')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }